import axios from "axios";
import API_PATH from "../config/API_PATH";

async function unwrap(promise) {
  const { data } = await promise;
  if (data?.success === false) {
    throw new Error(data?.errorMessage || data?.message || "Request failed");
  }
  return data;
}

export const fetchMiniGameSpinUser = () =>
  unwrap(axios.get(API_PATH.miniGameSpinUser));

export const fetchMiniGameSpinHistory = (params) =>
  unwrap(axios.get(API_PATH.miniGameSpinHistory, { params }));

export const fetchMiniGameMissions = () =>
  unwrap(axios.get(API_PATH.miniGameMissions));

export const fetchMiniGameGetMiniGame = () =>
  unwrap(axios.get(API_PATH.miniGameGetMiniGame));

export const fetchMiniGameListWinner = ({ type }) =>
  unwrap(
    axios.get(API_PATH.miniGameListWinner, {
      params: { my_winner: type },
    })
  );

export const fetchMiniGameAwardList = () =>
  unwrap(axios.get(API_PATH.miniGameAwardList));

export const fetchMiniGameRanking = () =>
  unwrap(axios.get(API_PATH.miniGameRanking));

export const fetchMiniGameRules = () =>
  unwrap(axios.get(API_PATH.miniGameRules));


export const fetchMiniGamePrizeCollection = () =>
  unwrap(axios.get(API_PATH.miniGamePrizeCollection));

export const fetchMiniGamePieceCollected = (params) =>
  unwrap(axios.get(API_PATH.miniGamePieceCollected, { params }));

export const fetchMiniGameHistory = (params) =>
  unwrap(axios.get(API_PATH.miniGameHistory, { params }));

export const fetchMiniGameWinnerList = (params) =>
  unwrap(axios.get(API_PATH.miniGameLisWinner, { params }));

export const postMiniGamePlayLoto = (body) =>
  unwrap(axios.post(API_PATH.miniGamePlayLoto, body));

export const postMiniGamePlayLotoMultiple = (body) =>
  unwrap(axios.post(API_PATH.miniGamePlayLotoMultiple, body));

export const postMiniGameTakePrize = (body) =>
  unwrap(axios.post(API_PATH.miniGameTakePrize, body));

export const postMiniGameChangeAttempt = (body) =>
  unwrap(axios.post(API_PATH.miniGameChangeAttempt, body));
